var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngineprimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M456,160h-16c-4.418,0-8,3.582-8,8v24h-16v-48c0-4.418-3.582-8-8-8h-72v-16h32c4.418,0,8-3.582,8-8V80    c0-4.418-3.582-8-8-8H232c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h32v16h-64c-0.961-0.001-1.915,0.17-2.816,0.504    L134.544,160H72c-4.418,0-8,3.582-8,8v64H48v-64c0-4.418-3.582-8-8-8H8c-4.418,0-8,3.582-8,8v184c0,4.418,3.582,8,8,8h32    c4.418,0,8-3.582,8-8v-64h16v64c0,4.418,3.582,8,8,8h61.336l61.864,46.4c1.385,1.039,3.069,1.6,4.8,1.6h168    c1.817,0.001,3.581-0.617,5-1.752l40-32c1.897-1.519,3.001-3.818,3-6.248v-40h16v24c0,4.418,3.582,8,8,8h16    c13.255,0,24-10.745,24-24V184C480,170.745,469.255,160,456,160z M32,240v104H16V176h16V240z M64,272H48v-24h16V272z M240,104V88    h120v16H240z M320,120v16h-40v-16H320z M464,336c0,4.418-3.582,8-8,8h-8v-24c0-4.418-3.582-8-8-8h-32c-4.418,0-8,3.582-8,8v44.16    L365.192,392H202.664L140.8,345.6c-1.385-1.039-3.069-1.6-4.8-1.6H80V176h56c0.961,0.001,1.915-0.17,2.816-0.504L201.456,152H400    v48c0,4.418,3.582,8,8,8h32c4.418,0,8-3.582,8-8v-24h8c4.418,0,8,3.582,8,8V336z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#3E3E3E"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.446,234.142c-1.48-1.376-3.425-2.141-5.446-2.142h-26.208l25.152-44c2.209-3.826,0.898-8.719-2.928-10.928    c-1.221-0.705-2.606-1.075-4.016-1.072h-64c-3.534,0-6.65,2.319-7.664,5.704l-24,80c-1.268,4.232,1.135,8.691,5.367,9.959    c0.745,0.223,1.519,0.337,2.297,0.337h19.576l-34.856,76.688c-1.824,4.024-0.04,8.765,3.984,10.589    c3.127,1.417,6.81,0.681,9.152-1.829l104-112C336.865,242.213,336.681,237.151,333.446,234.142z M251.68,310.4l19.6-43.12    c1.811-4.03,0.013-8.765-4.017-10.577c-1.026-0.461-2.138-0.701-3.263-0.703h-21.248l19.2-64h44.256l-25.152,44    c-2.209,3.826-0.898,8.719,2.928,10.928c1.221,0.705,2.606,1.075,4.016,1.072h21.656L251.68,310.4z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#3E3E3E"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineprimary);
export default __webpack_public_path__ + "static/media/engineprimary.8179ce35a0b9b232dbdff1fedbe84dbf.svg";
export { ForwardRef as ReactComponent };